<!--
================================================================
     ██╗███████╗    ███████╗ ██████╗██████╗ ██╗██████╗ ████████╗
     ██║██╔════╝    ██╔════╝██╔════╝██╔══██╗██║██╔══██╗╚══██╔══╝
     ██║███████╗    ███████╗██║     ██████╔╝██║██████╔╝   ██║   
██   ██║╚════██║    ╚════██║██║     ██╔══██╗██║██╔═══╝    ██║   
╚█████╔╝███████║    ███████║╚██████╗██║  ██║██║██║        ██║   
 ╚════╝ ╚══════╝    ╚══════╝ ╚═════╝╚═╝  ╚═╝╚═╝╚═╝        ╚═╝   
================================================================
-->
<script setup>
  import { computed, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { useMainStore } from '../store/index';
  import InformationModal from './InformationModal';
  import CookieForm from './CookieForm';

  const store = useMainStore();

  const imageInformation = {
    title: 'images',
    text: 'imageDisclaimerText',
  };

  const regulationsModal = computed(() => {
    return {
      title: 'serviceRegulation',
      text: store.selectedPaymentType === 'cash' ? 'approveRegulationsCashText' : 'approveRegulationsText',
    };
  });

  const showRegulationModal = computed(() => store.activeMarket?.showRegulationModal);


  const showPriceDisclaimer = computed(() => {
    // return useRoute().name === 'SummaryView';
    return true;
  });

  const euriborDate = computed(() => {
    return [store.misc?.euriborDate];
  });

  const openCookieForm = ref(false);

</script>

<!--
=============================================================================================================
██╗  ██╗████████╗███╗   ███╗██╗         ████████╗███████╗███╗   ███╗██████╗ ██╗      █████╗ ████████╗███████╗
██║  ██║╚══██╔══╝████╗ ████║██║         ╚══██╔══╝██╔════╝████╗ ████║██╔══██╗██║     ██╔══██╗╚══██╔══╝██╔════╝
███████║   ██║   ██╔████╔██║██║            ██║   █████╗  ██╔████╔██║██████╔╝██║     ███████║   ██║   █████╗  
██╔══██║   ██║   ██║╚██╔╝██║██║            ██║   ██╔══╝  ██║╚██╔╝██║██╔═══╝ ██║     ██╔══██║   ██║   ██╔══╝  
██║  ██║   ██║   ██║ ╚═╝ ██║███████╗       ██║   ███████╗██║ ╚═╝ ██║██║     ███████╗██║  ██║   ██║   ███████╗
╚═╝  ╚═╝   ╚═╝   ╚═╝     ╚═╝╚══════╝       ╚═╝   ╚══════╝╚═╝     ╚═╝╚═╝     ╚══════╝╚═╝  ╚═╝   ╚═╝   ╚══════╝
=============================================================================================================
-->
<template>
  <footer class="sdds-footer">
    <div class="sdds-footer-main">
      <ul class="sdds-footer-main-links">
        <li v-if="showRegulationModal">
          <a
            id="regulationsModal"
            href="#"
            data-dd-action-name="service regulation"
            @click.prevent
          >{{ $i18n('serviceRegulation') }}</a>
        </li>
        <li
          v-for="link in store.footerLinkMetadataForActiveMarket"
          :key="link.page"
        >
          <a
            :href="link.link"
            target="_blank"
          >
            {{ $i18n(link.title) }}
          </a>
        </li>
        <li>
          <div
            id="imagesModalId"
          >
            <a
              data-analytics="{'eventComponent':'footer','eventType':'modal','eventLabel':'images information modal'}"
              href="#"
              data-dd-action-name="images information modal"
              @click.prevent
            >{{ $i18n('images') }}</a>
          </div>
        </li>
        <li>
          <div
            id="cookieModalId"
          >
            <a
              data-analytics="{'eventComponent':'footer','eventType':'modal','eventLabel':'cookie modal settings'}"
              href="#"
              data-dd-action-name="cookie modal settings"
              @click="openCookieForm = true"
            >{{ $i18n('cookiesText') }}</a>
          </div>
        </li>
      </ul>
      <div class="sdds-footer-main-brand">
        <!-- <p
          v-if="showPriceDisclaimer && store.selectedPaymentType === 'leasing'"
          class="price-disclaimer"
        >
          {{ $i18n('priceDisclaimerText', euriborDate) }}
        </p> -->
        <!-- <p
          v-if="showPriceDisclaimer && store.selectedPaymentType === 'cash'"
          class="price-disclaimer"
        >
          {{ $i18n('priceDisclaimerCashText', euriborDate) }}
        </p> -->
        <p>{{ $i18n('copyrightText') }}</p>
      </div>
    </div>
    <InformationModal
      id="imagesModalId"
      :title="imageInformation.title"
      :information-text="imageInformation.text"
    />
    <InformationModal
      id="regulationsModal"
      :title="regulationsModal.title"
      :information-text="regulationsModal.text"
    />
    <CookieForm
      v-if="openCookieForm"
      @close="openCookieForm = false"
    />
  </footer>
</template>

<!--
======================================================================
 ██████╗███████╗███████╗    ███████╗████████╗██╗   ██╗██╗     ███████╗
██╔════╝██╔════╝██╔════╝    ██╔════╝╚══██╔══╝╚██╗ ██╔╝██║     ██╔════╝
██║     ███████╗███████╗    ███████╗   ██║    ╚████╔╝ ██║     █████╗  
██║     ╚════██║╚════██║    ╚════██║   ██║     ╚██╔╝  ██║     ██╔══╝  
╚██████╗███████║███████║    ███████║   ██║      ██║   ███████╗███████╗
 ╚═════╝╚══════╝╚══════╝    ╚══════╝   ╚═╝      ╚═╝   ╚══════╝╚══════╝
======================================================================
-->
<style scoped>
  .sdds-footer-main {
    background-color: var(--sdds-grey-900);
    color: var(--sdds-white);
  }
  .sdds-footer-main-links {
    text-transform: uppercase;
  }
  .sdds-footer-main .sdds-footer-main-brand {
    border-color: var(--sdds-white);
  }
  .sdds-footer-main .sdds-footer-main-brand > p:first-child {
    margin-bottom: var(--sdds-spacing-layout-16);
  }
  a {
    border-bottom: 0px;
  }
  .price-disclaimer {
    font-style: italic;
    margin-bottom: var(--sdds-spacing-layout-16);
  }
</style>
